import 'uni-pages';
import Vue from 'vue'
import Page from './demo/pages/index/index.vue'
createPage(Page)